module.exports = __webpack_public_path__ + "static/media/pill.9ff280ff.png";